import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

interface JourneyStep {
  icon: React.ReactNode;
  title: string;
  description: string;
  features: string[];
}

interface JourneyTimelineProps {
  steps: JourneyStep[];
}

const JourneyTimeline: React.FC<JourneyTimelineProps> = ({ steps }) => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        {steps.map((step, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="mb-20 last:mb-0"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div className={`order-2 ${index % 2 === 0 ? 'md:order-2' : 'md:order-1'}`}>
                <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-8 rounded-2xl shadow-lg">
                  <div className="aspect-video relative bg-white rounded-lg overflow-hidden">
                    <div className="absolute inset-0 flex items-center justify-center">
                      {step.icon}
                    </div>
                  </div>
                </div>
              </div>
              <div className={`order-1 ${index % 2 === 0 ? 'md:order-1' : 'md:order-2'}`}>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mr-6">
                    <span className="text-2xl font-bold text-blue-600">{index + 1}</span>
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold mb-4">{step.title}</h3>
                    <p className="text-xl text-gray-600 mb-6">{step.description}</p>
                    <ul className="space-y-3">
                      {step.features.map((feature, i) => (
                        <li key={i} className="flex items-center text-gray-600">
                          <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                          <span className="text-lg">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default JourneyTimeline;